// src/lib/fontawesome.js
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faQrcode,
  faXmark,
  faRightToBracket,
  faUserPlus,
  faArrowRightFromBracket,
  faMagnifyingGlassArrowRight,
  faBars,
  faUser,
  faUsers,
  faCogs,
  faFilter,
  faAngleDown,
  faCamera,
  faFileUpload,
  faPenToSquare,
  faAward,
  faRankingStar,
  faClipboardList,
  faStar,
  faTrophy,
  faCoins,
  faArrowRightArrowLeft,
  faTrash,
  faListOl,
  faArrowUp,
  faArrowDown,
  faGear,
  faEye,
  faBookBookmark,
  faSchool,
  faCopy,
  faUserXmark,
  faUserCheck,
  faStore,
  faPlus,
  faBullseye,
  faChevronLeft,

  // Nuevos íconos para recompensas
  faCrown,
  faMedal,
  faGift,
  faBox,
  faDice,
  faWandMagicSparkles,
  faPaintBrush,
  faPalette,
  faPencil,
  faPenNib,
  faLightbulb,
  faFutbol,
  faBasketball,
  faVolleyball,
  faRunning,
  faBicycle,
  faBook,
  faGraduationCap,
  faChalkboard,
  faBrain,
  faMagnifyingGlass,
  faFaceSmile,
  faFaceLaughBeam,
  faFaceGrinStars,
  faThumbsUp,
  faHandsClapping,
  faGem,
  faDiamond,
  faMoneyBill,
  faWallet,
  faRobot,
  faRocket,
  faHammer,
  faGhost,
  faDragon,
  faWandSparkles,
  faFire,
  faHeart,
  faIceCream,
  faPizzaSlice,
  faMap,
  faCompass,
  faBinoculars,
  faFlag,
  faPlane,
  faCakeCandles,
  faCartShopping,
  faGlasses,
  faShirt,
  faMask,
  faFaceKissBeam,
  faCheck,
  faFloppyDisk,
  faHandshake,
  faEyeSlash,
  faPeopleGroup,
  faChartBar,
  faBasketShopping,
  faAnglesUp,
  faStopwatch,
  faChevronDown,
  faChevronUp,
  faInbox,
} from "@fortawesome/free-solid-svg-icons";

import { faUser as farUser, faEye as farEye } from "@fortawesome/free-regular-svg-icons";

library.add(
  faQrcode,
  faXmark,
  faRightToBracket,
  faUserPlus,
  faArrowRightFromBracket,
  faMagnifyingGlassArrowRight,
  faBars,
  faUser,
  farUser,
  faUsers,
  faCogs,
  faFilter,
  faAngleDown,
  faCamera,
  faFileUpload,
  faPenToSquare,
  faAward,
  faRankingStar,
  faClipboardList,
  faStar,
  faTrophy,
  faCoins,
  faArrowRightArrowLeft,
  faTrash,
  faListOl,
  faArrowUp,
  faArrowDown,
  faGear,
  faEye,
  faBookBookmark,
  faSchool,
  faCopy,
  faUserXmark,
  faUserCheck,
  faStore,
  faPlus,
  faCartShopping,
  faBullseye,
  faChevronLeft,

  // 🎖 Recompensas
  faCrown,
  faMedal,
  faGift,
  faBox,
  faDice,
  faWandMagicSparkles,
  faPaintBrush,
  faPalette,
  faPencil,
  faPenNib,
  faLightbulb,
  faFutbol,
  faBasketball,
  faVolleyball,
  faRunning,
  faBicycle,
  faBook,
  faGraduationCap,
  faChalkboard,
  faBrain,
  faMagnifyingGlass,
  faFaceSmile,
  faFaceLaughBeam,
  faFaceGrinStars,
  faThumbsUp,
  faHandsClapping,
  faGem,
  faDiamond,
  faMoneyBill,
  faWallet,
  faRobot,
  faRocket,
  faHammer,
  faGhost,
  faDragon,
  faWandSparkles,
  faFire,
  faHeart,
  faIceCream,
  faPizzaSlice,
  faMap,
  faCompass,
  faBinoculars,
  faFlag,
  faPlane,
  faCakeCandles,
  faGlasses,
  faShirt,
  faMask,
  faFaceKissBeam,
  farEye,
  faCheck,
  faFloppyDisk,
  faHandshake,
  faEyeSlash,
  faPeopleGroup,
  faChartBar,
  faBasketShopping,
  faAnglesUp,
  faStopwatch,
  faChevronDown,
  faChevronUp,
  faInbox
);
